import Log from '../../common/log';
import { SessionsTag } from '../../common/Constants';
/**
 * Manages retry logic with configurable max retries and delays
 */
export default class RetryPolicy {
    constructor(maxRetries = 3, retryDelay = 100) {
        this.retryCounter = 0;
        this.maxRetries = maxRetries;
        this.retryDelay = retryDelay;
    }
    /**
     * Decide whether to retry a failed request
     * @param requestDescription - Description of the request for logging
     * @returns Retry decision with delay
     */
    shouldRetry(requestDescription) {
        if (this.retryCounter < this.maxRetries) {
            Log.debug(SessionsTag, `${requestDescription} failed ${this.retryCounter + 1}/${this.maxRetries}. Retrying...`);
            this.retryCounter++;
            return {
                shouldRetry: true,
                delay: this.retryDelay
            };
        }
        Log.warn(SessionsTag, `${requestDescription} failed. Discarding request...`);
        return {
            shouldRetry: false,
            delay: 0
        };
    }
    /**
     * Reset retry counter (call after successful request)
     */
    reset() {
        this.retryCounter = 0;
    }
    /**
     * Get current retry count
     */
    getRetryCount() {
        return this.retryCounter;
    }
    /**
     * Get max retries
     */
    getMaxRetries() {
        return this.maxRetries;
    }
    /**
     * Set max retries
     */
    setMaxRetries(maxRetries) {
        if (typeof maxRetries === 'number' && maxRetries >= 0) {
            this.maxRetries = maxRetries;
        }
    }
}
